// @core/api/endpoints/billing/create_billing_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateBillingProductRequest,
  CreateBillingProductResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Create product
 * Creates a new billable product that can be added to invoices and subscriptions. Products have associated prices that define billing terms.
 */
export async function CreateBillingProduct(
  data: CreateBillingProductRequest,
  options?: RequestOptions
): Promise<CreateBillingProductResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products`;
  const requestOptions = options;
  return client.post<CreateBillingProductResponse>(requestPath, data, requestOptions);
}
